export const languageTags: Record<string, string> = {
  en: 'en-US',
  ja: 'ja-JP',
};
